<script setup>
import { computed, defineAsyncComponent, onMounted, onUnmounted } from 'vue'
import Table from '@common/Table'
import Pagination from '@common/Pagination'
import SectionHeading from '@common/SectionHeading'
import { useStore } from '@admin_js/store'
import Filters from '@admin_ui/Components/Common/Filters/Filters'
import ShowFiltersButton from '../../Components/Common/Filters/ShowFiltersButton'

const store = useStore()

const props = defineProps({
  items: {
    type: [Array, Object],
  },
  resource: {
    type: String,
    required: true,
  },
  filters: {
    type: Object,
    default: [],
  },
})

onMounted(() => {
  store.setResource(props.resource)
  store.setFilters(props.resource, props.filters)
})

onUnmounted(() => {
  store.unsetFilters()
})

const isPaginated = computed(() => {
  return props.items.hasOwnProperty('data')
})

const loadComponent = (component) => {
  return defineAsyncComponent(() => import(`@admin_ui/Components/${component}`))
}
</script>

<template>
  <div class="relative min-h-screen">
    <SectionHeading :label="$attrs.title" :link="$attrs.routes.create">
      <template v-slot:actions></template>
      <template v-slot:after-actions>
        <div class="flex items-stretch space-x-4">
          <component
            v-bind:is="loadComponent(dynamicComponent)"
            v-for="dynamicComponent in $attrs.dynamicComponents"
          />
          <ShowFiltersButton v-if="store.resourceHasFilters()" />
        </div>
      </template>
    </SectionHeading>

    <Filters />

    <Table
      :items="items.data ?? items"
      :headers="$attrs.headers"
      :routes="$attrs.routes"
      :delete-message="$attrs.deleteMessage"
    ></Table>
    <Pagination v-if="isPaginated" :items="items"></Pagination>
  </div>
</template>
